<div class="row mb-2">
  <div class="col-md-12 d-flex justify-content-between align-items-center mb-3">
    <h3 class="mb-0">User Search Details</h3>

    <button type="button" class="btn btn-primary" (click)="backToList()">
      <i class="fa fa-arrow-left mr-1"></i>
      Back
    </button>
  </div>
</div>

<div *ngIf="loading" class="text-center mt-5 mb-5">
  <i class="fa fa-spinner fa-spin fa-2x"></i>
  <div class="mt-2">Loading...</div>
</div>

<div *ngIf="!loading && searchDetails" class="row">
  <!-- User Details -->

  <div class="col-md-6">
    <div class="main-card mb-3 card">
      <div
        class="card-header d-flex justify-content-between align-items-center font-weight-bold fs-1r"
      >
        <span>User Details</span>
      </div>

      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Name</div>

          <div class="col-md-8">
            {{ searchDetails.user?.name || "-" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Mobile</div>

          <div class="col-md-8">
            {{ searchDetails.user?.mobile || "-" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Email</div>

          <div class="col-md-8">
            {{ searchDetails.user?.email || "-" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">User ID</div>

          <div class="col-md-8">
            {{ searchDetails.userId || "-" }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Search Details -->

  <div class="col-md-6">
    <div class="main-card mb-3 card">
      <div
        class="card-header d-flex justify-content-between align-items-center font-weight-bold fs-1r"
      >
        <span>Search Details</span>
      </div>

      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">From City</div>

          <div class="col-md-8">
            <i class="fa fa-map-marker text-success mr-1"></i>
            {{ searchDetails.search?.pickupLocationCity || "-" }}
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">To City</div>

          <div class="col-md-8">
            <i class="fa fa-map-marker text-danger mr-1"></i>
            {{ searchDetails.search?.dropLocationCity || "-" }}
          </div>
        </div>

        <!-- <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Search Type</div>

          <div class="col-md-8">
            <span class="badge badge-success" *ngIf="searchDetails.searchType">
              {{ searchDetails.searchType }}
            </span>

            <span *ngIf="!searchDetails.searchType"> - </span>
          </div>
        </div> -->

        <div class="row mb-3">
          <div class="col-md-4 font-weight-bold">Searched On</div>

          <div class="col-md-8">
            {{
              searchDetails.createdAt | date: "dd MMM yyyy hh:mm a" : "en-IN"
            }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Search Filters -->

  <!-- <div class="col-md-12">
    <div class="main-card mb-3 card">
      <div
        class="card-header d-flex justify-content-between align-items-center font-weight-bold fs-1r"
      >
        <span>Search Filters</span>
      </div>

      <div class="card-body">
        <div *ngIf="searchDetails.searchFilters" class="row">
          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Pickup State</div>

            <div>
              {{ searchDetails.searchFilters.pickupLocationState || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Vehicle</div>

            <div>
              {{ searchDetails.searchFilters.vehicleId || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Vehicle Tons</div>

            <div>
              {{ searchDetails.searchFilters.vehicleTonsId || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Vehicle Tyres</div>

            <div>
              {{ searchDetails.searchFilters.vehicleTyres || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Product Type</div>

            <div>
              {{ searchDetails.searchFilters.productType || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Vehicle Capacity Type</div>

            <div>
              {{ searchDetails.searchFilters.vehicleCapacityType || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Length</div>

            <div>
              {{ searchDetails.searchFilters.length || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Breadth</div>

            <div>
              {{ searchDetails.searchFilters.breathe || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Height</div>

            <div>
              {{ searchDetails.searchFilters.height || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Minimum Capacity</div>

            <div>
              {{ searchDetails.searchFilters.minCapacity || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Maximum Capacity</div>

            <div>
              {{ searchDetails.searchFilters.maxCapacity || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Review Filter</div>

            <div>
              {{ searchDetails.searchFilters.reviewFilter || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Verification Status</div>

            <div>
              {{ searchDetails.searchFilters.verificationStatus || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Posted From</div>

            <div>
              {{ searchDetails.searchFilters.PostedFromDate || "-" }}
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="font-weight-bold">Posted To</div>

            <div>
              {{ searchDetails.searchFilters.PostedToDate || "-" }}
            </div>
          </div>
        </div>

        <div
          *ngIf="!searchDetails.searchFilters"
          class="text-center text-muted"
        >
          No additional filters available.
        </div>
      </div>
    </div>
  </div> -->

  <!-- Search History ID -->

  <div class="col-md-12">
    <div class="main-card mb-3 card">
      <div class="card-header font-weight-bold fs-1r">Search Information</div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="font-weight-bold">Search History ID</div>

            <div class="text-muted">
              {{ searchDetails._id || "-" }}
            </div>
          </div>

          <div class="col-md-6">
            <div class="font-weight-bold">Created At</div>

            <div class="text-muted">
              {{
                searchDetails.createdAt
                  | date: "dd MMM yyyy hh:mm:ss a" : "en-IN"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- No Data -->

<div *ngIf="!loading && !searchDetails" class="main-card mb-3 card">
  <div class="card-body text-center">
    <div class="text-danger mt-5 mb-5">Search history details not found.</div>

    <button type="button" class="btn btn-secondary" (click)="backToList()">
      <i class="fa fa-arrow-left mr-1"></i>
      Back to List
    </button>
  </div>
</div>
